import React from 'react'

import MaintenanceContainer from '../components/alerts/MaintenanceContainer'

const MaintenanceScreen = props => <MaintenanceContainer />

export default MaintenanceScreen
